// extracted by mini-css-extract-plugin
export var chip = "Chip-module--chip--1JtD_";
export var chipPrimary = "Chip-module--chipPrimary--32Dtl";
export var chipSecondary = "Chip-module--chipSecondary--1Jz7z";
export var chipFill = "Chip-module--chipFill--21XzV";
export var show = "Chip-module--show--kg2Fc";
export var showFadeInDown = "Chip-module--show-fade-in-down--528qR";
export var showFadeInUp = "Chip-module--show-fade-in-up--1QWGD";
export var hideFadeOut = "Chip-module--hide-fade-out--q1uAW";